import { render } from "./region-list.vue?vue&type=template&id=a772854c"
import script from "./region-list.vue?vue&type=script&lang=js"
export * from "./region-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__